import { gql } from '@apollo/client';

export const LIST_INTEGRATION_CARDS = gql`
    query ($input: GetListDTO!) {
        listIntegrationCards(input: $input) {
            message
            integrationCards {
                _id
                name
                description
                linkName
                linkUrl
                logo
                isActive
                createdAt
                updatedAt
            }
            pagination {
                total
                hasNextPage
            }
        }
    }
`;

export const GET_INTEGRATION_CARD = gql`
    query ($id: String!) {
        getIntegrationCard(id: $id) {
            message
            integrationCard {
                _id
                name
                description
                linkName
                linkUrl
                logo
                isActive
            }
        }
    }
`;
